/* oxlint-disable typescript/no-explicit-any */
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/index.css';
import { IconSync } from '../icons/Sync';

export type TButtonTypes = 'primary' | 'secondary' | 'plain';

export interface IButtonProps extends React.HTMLProps<HTMLButtonElement> {
  type?: TButtonTypes;
  sync?: boolean;
  icon?: React.ReactNode;
  stack?: boolean;
  fluid?: boolean;
  active?: boolean;
  As?: 'button' | 'a';
  href?: string;
  target?: string;
}

export function Button(props: IButtonProps) {
  const { As = 'button', icon, type = 'plain', stack, sync, children, ...rest } = props;
  const { className, style } = rest;

  // tslint:disable-next-line: no-any
  const Hack = As as any;

  return (
    <Hack
      className={cx([
        styles['button'],
        styles[type],
        type === 'plain' && rest && rest.active && styles['active'],
        rest && rest.fluid && styles['fluid'],
        className,
        style && style,
        sync && styles['button_sync'],
      ])}
      {...rest}
    >
      {sync ? (
        <span className={styles['sync_outer']}>
          <IconSync active width={16} />
        </span>
      ) : null}
      {icon}
      <span className={cx(stack && styles['icon_text'])}>{children}</span>
    </Hack>
  );
}
